import { IconProps } from './Icon';

export const BillOutlineIcon = ({
  width,
  height,
  className,
  color,
}: IconProps) => (
  <svg
    className={className}
    color={color}
    height={height}
    viewBox="0 0 512.001 512.001"
    width={width}
    xmlns="http://www.w3.org/2000/svg"
  >
    <g>
      <g>
        <path
          d="M266.712,176.733h-21.424c-9.447,0-17.133-7.686-17.133-17.134c0-9.447,7.686-17.133,17.133-17.133h42.844
			c8.284,0,15-6.716,15-15s-6.716-15-15-15h-17.134V95.334c0-8.284-6.716-15-15-15s-15,6.716-15,15v17.337
			c-23.985,2.175-42.843,22.387-42.843,46.929c0,25.99,21.144,47.134,47.133,47.134h21.424c9.447,0,17.133,7.686,17.133,17.133
			c0,9.447-7.685,17.133-17.133,17.133h-42.847c-8.284,0-15,6.716-15,15s6.716,15,15,15h17.133v17.133c0,8.284,6.716,15,15,15
			c8.284,0,15-6.716,15-15v-17.337c23.987-2.174,42.847-22.386,42.847-46.93C313.845,197.877,292.702,176.733,266.712,176.733z"
        />
      </g>
    </g>
    <g>
      <g>
        <path
          d="M336.333,353.467H175.667c-8.284,0-15,6.716-15,15s6.716,15,15,15h160.666c8.284,0,15-6.716,15-15
			S344.617,353.467,336.333,353.467z"
        />
      </g>
    </g>
    <g>
      <g>
        <path
          d="M432.733,0H79.267c-8.284,0-15,6.716-15,15v437.816c0,3.978,1.581,7.793,4.394,10.607l44.184,44.184
			c5.857,5.858,15.355,5.858,21.213,0l33.577-33.577l33.576,33.577c2.813,2.813,6.628,4.394,10.607,4.394
			c3.978,0,7.794-1.58,10.607-4.394L256,474.03l33.577,33.577c2.813,2.813,6.628,4.394,10.606,4.394
			c3.979,0,7.794-1.581,10.607-4.394l33.576-33.577l33.577,33.577c2.929,2.929,6.767,4.394,10.606,4.394s7.678-1.464,10.607-4.394
			l44.184-44.184c2.813-2.813,4.394-6.629,4.394-10.607V15C447.733,6.716,441.018,0,432.733,0z M388.549,475.787l-33.577-33.577
			c-2.813-2.813-6.629-4.394-10.607-4.394c-3.979,0-7.794,1.581-10.607,4.394l-33.576,33.577l-33.577-33.577
			c-5.857-5.858-15.355-5.858-21.213,0l-33.577,33.577l-33.576-33.577c-2.813-2.813-6.628-4.394-10.607-4.394
			c-3.978,0-7.793,1.58-10.606,4.394l-33.577,33.577l-29.184-29.184V30h323.467v416.603h0.001L388.549,475.787z"
        />
      </g>
    </g>
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
    <g />
  </svg>
);
